import { render, staticRenderFns } from "./QuotationStepPolicy.vue?vue&type=template&id=45e09d2a"
import script from "./QuotationStepPolicy.vue?vue&type=script&lang=js"
export * from "./QuotationStepPolicy.vue?vue&type=script&lang=js"
import style0 from "./QuotationStepPolicy.vue?vue&type=style&index=0&id=45e09d2a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports